// "The 13,000-Token Bug — Why Your Chatbot Gets Slower As You Talk" — EAKC chat latency.
// Cold Compute / Neon kit. ~86s @ 30fps. The real session forensics:
//   31-char query → 13,839 input tokens → 72s on gemini-2.5-pro.
//   Cause: conversation history capped by MESSAGE COUNT, not SIZE.
//   Fix: token/size-budget the history + model → Flash. 72s → 4.3s.
// Grounded in EAKC-MVP:
//   agent_usage_logs (total_latency_ms, tokens_in) · src/lib/chat/trim-history.ts
//   src/app/api/v1/chat/completions/route.ts (history load) · model_config (deep→flash)
//   research: docs/2026-06-09-conversation-memory-and-self-evolving-companion-research.md
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; keep contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //       0:00–0:05  31 chars in, 13k tokens out, 72s
  forensics: { start: 150, duration: 450 }, //0:05–0:20  agent_usage_logs — the smoking gun
  why: { start: 600, duration: 420 }, //      0:20–0:34  less context is MORE accurate (Context Rot)
  fix: { start: 1020, duration: 480 }, //     0:34–0:50  size-budget the history (trim-history.ts) + Flash
  result: { start: 1500, duration: 390 }, //  0:50–1:03  72s → 4.3s
  lesson: { start: 1890, duration: 420 }, //  1:03–1:17  quality is a context problem, not a model problem
  outro: { start: 2310, duration: 270 }, //   1:17–1:26
} as const;

export const TOTAL_DURATION = 2580; // 86s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
